// @flow
// $FlowFixMe - Cannot import useEffect because there is no useEffect export in react.
import React, { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import type { SelectOption, SelectOptions } from './types';
import SelectCreatable from './SelectCreatable';

type SelectCreatableHookFormProps = {
  defaultValue?: string | boolean | number,
  name: string,
  options: SelectOptions,
  rules: any,
  'aria-label': string,
  isLoading: boolean,
  onChange?: SelectOption => void,
};

const SelectCreatableHookForm = ({
  defaultValue,
  name,
  options,
  rules,
  isLoading,
  onChange,
  ...props
}: SelectCreatableHookFormProps) => {
  const { control, setValue } = useFormContext();

  useEffect(() => {
    const defaultValueOption = options.find(option => option.value === defaultValue);
    // set default as value after loading options is done
    if (defaultValueOption && !isLoading) {
      setValue(name, defaultValueOption);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setValue, isLoading]);

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({
        field: { onChange: onChangeController, onBlur, value },
        fieldState: { error },
      }) => (
        <SelectCreatable
          isLoading={isLoading}
          errorText={error?.message}
          onBlur={onBlur}
          onChange={typeof onChange === 'function' ? onChange : onChangeController}
          options={options}
          value={value}
          {...props}
        />
      )}
    />
  );
};

SelectCreatableHookForm.defaultProps = {
  defaultValue: undefined,
};

export default SelectCreatableHookForm;
